import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getDriverDetailsWithIdApi, getAllDriversDetailsApi } from "../api/dashboard";
import { getSecondaryDriverAndVendorDetailsAPI } from "../api/onboarding";
import { act } from "react";
// import { useDispatch } from 'react-redux';
// const dispatch = useDispatch()
export const fetchDriverDetailsWithId = createAsyncThunk(
  "dashboard/driver/details",
  async (driverId) => {
    try {
      const response = await getDriverDetailsWithIdApi(driverId);
      return response;
    } catch (error) {
      // return error;
      throw error;
    }
  }
);

export const getSecondaryDriverAndVendorDetails = createAsyncThunk(
  "dashboard/secondar-driver",
  async (primaryDriverId) => {
    try {
      const response = await getSecondaryDriverAndVendorDetailsAPI(primaryDriverId);
      //
      return response;
    } catch (error) {
      throw error;
    }
  }
);
export const fetchDriverAllDetails = createAsyncThunk(
  "dashboard/all/driver",
  async (limit, page) => {
    try {
      const response = await getAllDriversDetailsApi(); // TODO why same api being called in here in redux as well as ../api/dashboard --> status api is called twice in network tab when loading any dashboard table
      // const response = await getAllDriversDetailsApi(1000000);

      return response;
    } catch (error) {
      return error;
    }
  }
);
// for onboard agent
const driverDetailsWithIdSlice = createSlice({
  name: "getDriverDetailsWithId",
  initialState: {
    driverId: null,
    detailsUpdatedDriverId: null,
    // data: {},
    onboarding: {},
    onboardingUpdated: {},
    verification: {},
    verificationUpdated: {},
    allocationData: {},
    schemeDetails: {},
    paymentHistory: [],
    vehicleAssignData: {},
    walletDetails: {},
    assigned_emi_detail: {},
    settlementDetails: {},
    isWaiverButtonActive: false,
    canCarBeAutoAssigned: null,
    canCarBeAutoAssignedReason: null,
    schemeDeleted: null,
    isSDMDriverRelated: false,
    canSecondaryBecomePrimary: false,
    leadData: {},
    checks: {},
    isPrimaryDriver: true,
    error: null,
    isLoading: false,
    canOAEditAfterDR: false,
    canDMReactivate: false,
    chequeData: [],
  },
  reducers: {
    updateDriverReduxDetails: (state, action) => {
      state.onboarding = action.payload;
      // state.driverId = state.id
    },
    updateDriverOnboardingDetails: (state, action) => {
      state.onboardingUpdated = action.payload.data;
      state.detailsUpdatedDriverId = action.payload.driverId;
    },
    updateVerificationReduxDetails: (state, action) => {
      state.verification = action.payload;
    },
    updatedVerificationReduxDetails: (state, action) => {
      state.verificationUpdated = action.payload.data;
      state.detailsUpdatedDriverId = action.payload.driverId;
    },
    updateAllocationReduxDetails: (state, action) => {
      state.allocationData = action.payload.data;
      state.detailsUpdatedDriverId = action.payload.driverId;
    },
    updateChequeData: (state, action) => {
      state.chequeData = action.payload || [];
    },
    updateDriverId: (state, action) => {
      state.driverId = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchDriverDetailsWithId.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(fetchDriverDetailsWithId.fulfilled, (state, action) => {
      state.isLoading = false;
      state.error = null;
      // state.data = action.payload?.onboarding;
      // state.onboarding = action.payload?.onboarding;
      state.onboarding = {
        ...action.payload?.onboarding,
        driverStatusCurrent: action.payload?.onboarding?.status,
        initialLanguage: action.payload?.onboarding?.Languages,
      };
      state.driverId = state.onboarding?.id;
      state.verification = action.payload?.verification;
      state.verification.initalDOB = action.payload?.verification?.date_of_birth;
      state.allocationData = action.payload?.allocationData;
      state.schemeDetails = action.payload?.schemeDetails;
      state.paymentHistory = action.payload?.paymentHistory;
      state.vehicleAssignData = action.payload?.vehicleAssignData;
      state.walletDetails = action.payload?.walletDetails;
      state.assigned_emi_detail = action.payload?.assigned_emi_detail;
      state.settlementDetails = action.payload?.settlementDetails;
      state.canOAEditAfterDR = action.payload?.canOAEditAfterDR;
      state.canDMReactivate = action.payload?.canDMReactivate;
      state.isWaiverButtonActive = action.payload?.isWaiverButtonActive;
      state.canCarBeAutoAssigned = action.payload?.canCarBeAutoAssigned;
      state.canCarBeAutoAssignedReason = action.payload?.canCarBeAutoAssignedReason;
      state.schemeDeleted = action.payload?.schemeDeleted;
      state.isSDMDriverRelated = action.payload?.isSDMDriverRelated;
      state.canSecondaryBecomePrimary = action.payload?.canSecondaryBecomePrimary;
      state.checks = action.payload?.checks;
      state.isPrimaryDriver = action.payload?.isPrimaryDriver;
      state.leadData = action.payload?.leadData;
      state.chequeData = (action.payload?.chequeData || []).map((item) => ({
        id: item?.id,
        pic: Array.isArray(item?.image) ? item.image : [],
        uploaded: true,
        bankNumber: item?.bankNumber || "",
        createdAt: item?.createdAt,
      }));
    });
    builder.addCase(fetchDriverDetailsWithId.rejected, (state, action) => {
      state.isLoading = false;
      state.error = action.error;
    });
  },
});

const driverVerificationDetails = createSlice({
  name: "driverVerificationDetails",
  initialState: {
    driverId: null,
    data: {},
    error: null,
    isLoading: false,
  },
  reducers: {
    updateDriverReduxVerificationDetails: (state, action) => {
      state.data = action.payload;
      state.driverId = state.data.id;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchDriverDetailsWithId.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(fetchDriverDetailsWithId.fulfilled, (state, action) => {
      state.isLoading = false;
      state.data = action.payload;
      state.driverId = state.data.id;
    });
    builder.addCase(fetchDriverDetailsWithId.rejected, (state, action) => {
      state.isLoading = false;
      state.error = action.error;
    });
  },
});

const driverAllDetailsSlice = createSlice({
  name: "getAllDrisverDetails",
  initialState: {
    data: {},
    error: null,
    isLoading: false,
  },
  reducers: {
    updateAllDriverReduxDetails: (state, action) => {
      state.data = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchDriverAllDetails.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(fetchDriverAllDetails.fulfilled, (state, action) => {
      state.isLoading = false;
      state.data = action.payload;
    });
    builder.addCase(fetchDriverAllDetails.rejected, (state, action) => {
      state.isLoading = false;
      state.error = action.error;
    });
  },
});
const driverUpdatedDetails = createSlice({
  name: "driverUpdatedDetails",
  initialState: {
    driverId: null,
    data: {},
    error: null,
    isLoading: false,
  },
  reducers: {
    insertDriverDetails: (state, action) => {
      if (action.payload.data) {
        state.data = action.payload.data;
      }
      if (action.payload.driverId) {
        state.driverId = action.payload?.driverId;
      }
    },
  },
});

const doubleDriverDetail = createSlice({
  name: "doubleDriverDetail",
  initialState: {
    data: {},
    creatingData: {},
    primaryDriverData: {},
    secondaryDriverData: {},
    error: null,
    isLoading: false,
  },
  reducers: {
    creatingDoubleDriverReduxData: (state, action) => {
      state.creatingData = action.payload;
    },
    changeSecondaryDriverData: (state, action) => {
      state.secondaryDriverData = action.payload;
    },
    changePrimaryDriverData: (state, action) => {
      state.primaryDriverData = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getSecondaryDriverAndVendorDetails.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(getSecondaryDriverAndVendorDetails.fulfilled, (state, action) => {
      state.isLoading = false;
      const secondaryDrivers = action?.payload?.results?.secondaryDrivers?.filter(
        (item) => item?.status !== "inactive"
      );
      state.secondaryDriverData = secondaryDrivers;
      state.primaryDriverData = action.payload.results.primaryDriver;
    });
    builder.addCase(getSecondaryDriverAndVendorDetails.rejected, (state, action) => {
      state.isLoading = false;
      state.error = action.error;
    });
  },
});

export const driverDetailsWithId = driverDetailsWithIdSlice.reducer;
export const driverAllDetails = driverAllDetailsSlice.reducer;
export const addDriverUpdatedDetail = driverUpdatedDetails.reducer;
export const driverVerificationDetailsWithID = driverVerificationDetails.reducer;
export const doubleDriverReduxDetail = doubleDriverDetail.reducer;

export const updateDriverReduxDetails = driverDetailsWithIdSlice.actions.updateDriverReduxDetails;
export const insertDriverDetails = driverUpdatedDetails.actions.insertDriverDetails;
export const updateDriverReduxVerificationDetails =
  driverVerificationDetails.actions.updateDriverReduxVerificationDetails;
export const updateDriverOnboardingDetails =
  driverDetailsWithIdSlice.actions.updateDriverOnboardingDetails;
export const updateVerificationReduxDetails =
  driverDetailsWithIdSlice.actions.updateVerificationReduxDetails;
export const updatedVerificationDetails =
  driverDetailsWithIdSlice.actions.updatedVerificationReduxDetails;
export const updateDriverId = driverDetailsWithIdSlice.actions.updateDriverId;
export const updateAllocationReduxDetails =
  driverDetailsWithIdSlice.actions.updateAllocationReduxDetails;
export const updateChequeData = driverDetailsWithIdSlice.actions.updateChequeData;
export const creatingDoubleDriverReduxData =
  doubleDriverDetail.actions.creatingDoubleDriverReduxData;
export const changeSecondaryDriverData = doubleDriverDetail.actions.changeSecondaryDriverData;
export const changePrimaryDriverData = doubleDriverDetail.actions.changePrimaryDriverData;
